import {Component, Input, OnInit,Output,EventEmitter} from '@angular/core';

@Component({
  selector: 'app-analyticsloanperformancelog',
  templateUrl: './analyticsloanperformancelog.component.html',
  styleUrls: ['./analyticsloanperformancelog.component.css']
})
export class AnalyticsloanperformancelogComponent implements OnInit {
  @Input('details') details: any;
  @Input('loan') loan: any;
  loan_performance_log: any [];
  @Output() opencrawler = new EventEmitter();
  constructor() {
  }

  ngOnInit() {
    this.loan_performance_log = this.details.data.loan_performance;
  }
  openloancrawler(){

  }

}
